import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
// import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  creditCardSchema,
  creditCardListSchema,
  creditCardTokenSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/creditCards/actions';
import { CreditCardsActionTypes as types } from 'app/ducks/creditCards/types';
import { createCreditCardInAssembly } from 'app/utils/assembly';

function* createCreditCardSaga(action): any {
  yield put(sagaActions.createCreditCardPending());

  // const [creditCardError, creditCard] = yield createCreditCardInAssembly(
  //   action.payload,
  // );

  // if (creditCardError) {
  //   typeof DD_LOGS ?? DD_LOGS.logger.info('assembly-card-creation-error', {
  //     env: ENVIRONMENT,
  //     error: creditCardError,
  //   });
  //   yield put(
  //     sagaActions.createCreditCardFailed({
  //       message: 'Failed to process credit card details, please try again.',
  //     }),
  //   );
  // } else {
  //   typeof DD_LOGS ?? DD_LOGS.logger.info('assembly-card-creation-response', {
  //     env: ENVIRONMENT,
  //     response: creditCard,
  //     card_token: creditCard.id,
  //   });
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationCreditCards.create({
    token: action.payload.data.cardAccountId,
    status: action.payload.data.status,
    user: action.payload.data.user,
    teamMember: action.payload.data.teamMember,
    consumer: action.payload.data.consumer,
  });

  if (response) {
    const normalizedResponse = normalize(response, creditCardSchema);

    yield put(sagaActions.createCreditCardSuccess(normalizedResponse));
    if (action.payload.callbackFunction !== undefined) {
      action.payload.callbackFunction();
    }
  } else {
    if (action.payload.callbackFunction !== undefined) {
      action.payload.callbackFunction();
    }
    yield put(
      handleError(
        error,
        sagaActions.createCreditCardFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
  // }
}

function* createCreditCardTokenSaga(action): any {
  yield put(sagaActions.createCreditCardTokenPending());
  const [error, response] = yield (yield yield TeammoApi(
    yield select(),
  )).organisationCreateCreditCardTokens.create(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, creditCardTokenSchema);

    yield put(sagaActions.createCreditCardTokenSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createCreditCardTokenFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateCreditCardSaga(action): any {
  yield put(sagaActions.updateCreditCardPending(action.payload));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).organisationCreditCards.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, creditCardSchema);

    yield put(sagaActions.updateCreditCardSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateCreditCardFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getCreditCardSaga(action): any {
  yield put(sagaActions.getCreditCardPending());
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationCreditCards.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, creditCardSchema);
    yield put(sagaActions.getCreditCardSuccess(normalizedResponse));
    // if (!_.isEmpty(normalizedResponse.paymentEvent.id)) {
    //   yield put(yield getPaymentEvent(normalizedResponse.paymentEvent.id));
    // }

    return normalizedResponse.entities.creditCards[normalizedResponse.result];
  }
  yield put(
    handleError(
      error,
      sagaActions.getCreditCardFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllCreditCardsSaga(action): any {
  yield put(
    sagaActions.getAllCreditCardsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.creditCards.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationCreditCards.list(paginationObject);

  if (response) {
    const normalizedResponse = normalize(response, creditCardListSchema);

    yield put(
      sagaActions.getAllCreditCardsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllCreditCardsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createCreditCardSagaWatcher(): any {
  yield takeEvery(types.CREATE_CREDIT_CARD_REQUESTED, createCreditCardSaga);
}
function* createCreditCardTokenSagaWatcher(): any {
  yield takeEvery(
    types.CREATE_CREDIT_CARD_TOKEN_REQUESTED,
    createCreditCardTokenSaga,
  );
}

function* updateCreditCardSagaWatcher(): any {
  yield takeLatest(types.UPDATE_CREDIT_CARD_REQUESTED, updateCreditCardSaga);
}

function* getCreditCardSagaWatcher(): any {
  yield takeEvery(types.GET_CREDIT_CARD_REQUESTED, getCreditCardSaga);
}

function* getAllCreditCardsSagaWatcher(): any {
  yield takeEvery(types.GET_ALL_CREDIT_CARDS_REQUESTED, getAllCreditCardsSaga);
}

export default function* root(): any {
  yield all([
    createCreditCardSagaWatcher(),
    createCreditCardTokenSagaWatcher(),
    updateCreditCardSagaWatcher(),
    getCreditCardSagaWatcher(),
    getAllCreditCardsSagaWatcher(),
  ]);
}
